export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS';
export const SIGNOUT = 'SIGNOUT';
export const GET_USER_INFO = 'GET_USER_INFO';
export const RENEW_TOKEN = 'RENEW_TOKEN';